// extracted by mini-css-extract-plugin
export default {"App":"TistoryMain_App__4ZF4-"};